import React, { useCallback } from 'react';
import { Grid, Paper } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stock2 from '_assets/landingPage/images/740.jpg'
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';


function getHeader1(lang) {
    switch (lang) {
        case "FI":
            return "Uudet ominaisuudet"
            break;

        case "SE":
            return "Nya funktioner"
            break;

        default:
    }
}


function getHeader2(lang) {
    switch (lang) {
        case "FI":
            return "Spot - tarjoukset merirahteihin nyt jopa tunnissa"
            break;

        case "SE":
            return "Spot – offerter för sjö-, flyg- och större vägtransporter "
            break;

        default:
    }
}

function getHeader3(lang) {
    switch (lang) {
        case "FI":
            return "Lisäsimme nopeamman merirahtien tarjouspyyntöominaisuuden"
            break;

        case "SE":
            return "Utnyttja vårt nätverk av transportföretag."
            break;

        default:
    }
}

function getBody1(lang) {
    switch (lang) {
        case "FI":
            return "Uusin päivitys tuo asiakkaille entistä sujuvamman tavan hallita merirahtien tarjouspyyntöjä. Uusi ominaisuus mahdollistaa nopean ja vaivattoman hintavertailun, tarjoten läpinäkyvyyttä ja kustannustehokkuutta rahdinkuljetukseen. Voitte nyt luoda ja hallita tarjouspyyntöjä suoraan FreightOptin järjestelmässä yläpalkin “New Spot Request” osiossa. "
            break;

        case "SE":
            return "Den senaste uppdateringen ger er ett smidigt sätt att hantera era förfrågningar. Den nya funktionen möjliggör snabb och enkel prisjämförelse, vilket ger transparens och kostnadseffektivitet i fraktprocessen. Ni kan nu skapa och hantera offertförfrågningar direkt i FreightOpt-systemet under fliken “New Spot Request“ i den övre menyn."
            break;

        default:
    }
}

export function NewFeaturesModal({ open, handleClose, handleDontShowAgain, lang }) {


    return (
        <React.Fragment>

            <Dialog

                hideBackdrop={true}
                onClose={handleClose}
                open={open}


            >

                <Card sx={{ maxWidth: 550 }}>
                    <CardMedia
                        component="img"
                        height="250"
                        image={Stock2}

                        sx={{ zIndex: '1' }}
                    />
                    <Grid container sx={{ position: 'absolute', top: 0, zIndex: '999', pl: 2, pt: 1 }}>
                        <Grid item xs={11}>
                            <Typography variant="h6" sx={{ color: '#fff' }}>
                                {getHeader1(lang)}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: 'start' }}>
                            <IconButton aria-label="share" onClick={handleClose}>
                                <CloseIcon sx={{ color: '#a9a9a9' }} />
                            </IconButton>
                        </Grid>
                        <Grid item xs={12} sx={{ marginTop: '130px' }}>
                            <Typography variant="h5" sx={{ color: '#fff' }}>
                            {getHeader2(lang)}
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#fff' }}>
                            {getHeader3(lang)}
                            </Typography>
                        </Grid>
                    </Grid>

                    <CardContent>
                        <Grid container p={2}>
                            <Grid item xs={12}>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                {getBody1(lang)}
                                </Typography>
                            </Grid>
                        </Grid>

                    </CardContent>
                    <CardActions disableSpacing>
                        <Grid container item xs={12} pl={1}>
                            <FormControlLabel sx={{ color: '#a9a9a9' }} control={<Checkbox onChange={(e) => handleDontShowAgain(e.target.checked)} sx={{ color: '#a9a9a9' }} />} label="Don't show me this again" />
                        </Grid>

                    </CardActions>

                </Card>



            </Dialog>

        </React.Fragment>
    );

}





